import React from 'react';
import { useCurrency } from '../context/CurrencyContext';
import { FiChevronDown } from 'react-icons/fi';

export default function CurrencySelector() {
    const { currency, setCurrency } = useCurrency();
    const [isOpen, setIsOpen] = React.useState(false);
    const dropdownRef = React.useRef(null);

    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleCurrencyChange = (newCurrency) => {
        setCurrency(newCurrency);
        setIsOpen(false);
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center space-x-0.5 sm:space-x-1 text-white hover:text-pink-500 transition-colors text-xs sm:text-sm font-medium px-1 sm:px-0"
            >
                <span className="hidden sm:inline">{currency}</span>
                <span className="sm:hidden">{currency === 'USD' ? '$' : '₨'}</span>
                <FiChevronDown size={12} className={`transform transition-transform sm:w-3.5 sm:h-3.5 ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {isOpen && (
                <div className="absolute right-0 mt-2 w-24 bg-gray-900 border border-gray-800 rounded-lg shadow-xl z-50 overflow-hidden">
                    <button
                        onClick={() => handleCurrencyChange('USD')}
                        className={`block w-full text-left px-4 py-2 text-sm transition-colors ${currency === 'USD' ? 'bg-pink-500 text-white' : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                            }`}
                    >
                        USD ($)
                    </button>
                    <button
                        onClick={() => handleCurrencyChange('PKR')}
                        className={`block w-full text-left px-4 py-2 text-sm transition-colors ${currency === 'PKR' ? 'bg-pink-500 text-white' : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                            }`}
                    >
                        PKR (₨)
                    </button>
                </div>
            )}
        </div>
    );
}
